import { render, staticRenderFns } from "./WhichJerseyShore.vue?vue&type=template&id=12280b64&"
import script from "./WhichJerseyShore.vue?vue&type=script&lang=ts&"
export * from "./WhichJerseyShore.vue?vue&type=script&lang=ts&"
import style0 from "./WhichJerseyShore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports